var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"rotate-90",attrs:{"width":_vm.width,"data-name":"seat","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100 100"}},_vm._l((_vm.seatDimensions),function(seatDimension,index){return _c('path',{key:index,class:_vm.classifier,attrs:{"d":seatDimension.dimension}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }